import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';

const ViewLink = ({ urlPostback, gethParams, extraGethParams }) => {
    const [state, setState] = useState({
        urlPostback: urlPostback || '',
        gethParams: gethParams || []
    });

    const getParams = useCallback((list) => {
        let link = '';
        let count = 0;

        list.map((item, i) => {
            const value = item.macros || item.value;

            if (!item.name || !value) {
                return;
            }

            link += (count !== 0) ? '&' : '';
            link += `${item.name}=${value}`;
            count += 1;
        });

        return link;
    }, []);

    const getLink = useCallback(() => {
        let link = state.urlPostback;

        link += link ? '?' : '';
        link += getParams(state.gethParams);

        return link;
    }, [state.urlPostback, state.gethParams, getParams]);

    useEffect(() => {
        setState(prev => ({
            ...prev,
            urlPostback: urlPostback || prev.urlPostback,
            gethParams: gethParams || prev.gethParams
        }));
    }, [urlPostback, gethParams]);

    return (
        <div className="viewLink">
            {getLink()}
        </div>
    );
};

ViewLink.propTypes = {
    urlPostback: PropTypes.string,
    gethParams: PropTypes.array,
    extraGethParams: PropTypes.array
};

ViewLink.defaultProps = {
    urlPostback: '',
    gethParams: [],
    extraGethParams: []
};

export default ViewLink;
